// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/scribe/svc_analytics_model.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { AnalyticsModel, AnalyticsModelSummary, AnalyticsSectionSpec, AnalyticsSectionSpecList, AnalyticsTagsConfig, CatalogCloneOverride, CatalogCloneResult } from "../../model/dto_scribe_catalog_pb.js";

/**
 * @generated from message com.diagnocat.scribe.GetAnalyticsModelReq
 */
export const GetAnalyticsModelReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetAnalyticsModelReq",
  () => [
    { no: 1, name: "ModelID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetAnalyticsModelResp
 */
export const GetAnalyticsModelResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetAnalyticsModelResp",
  () => [
    { no: 1, name: "Model", kind: "message", T: AnalyticsModel },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetAnalyticsModelBySeriesIDReq
 */
export const GetAnalyticsModelBySeriesIDReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetAnalyticsModelBySeriesIDReq",
  () => [
    { no: 1, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetAnalyticsModelBySeriesIDResp
 */
export const GetAnalyticsModelBySeriesIDResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetAnalyticsModelBySeriesIDResp",
  () => [
    { no: 1, name: "Model", kind: "message", T: AnalyticsModel },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetAnalyticsModelByCodeReq
 */
export const GetAnalyticsModelByCodeReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetAnalyticsModelByCodeReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetAnalyticsModelByCodeResp
 */
export const GetAnalyticsModelByCodeResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetAnalyticsModelByCodeResp",
  () => [
    { no: 1, name: "Model", kind: "message", T: AnalyticsModel },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListAnalyticsModelsReq
 */
export const ListAnalyticsModelsReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListAnalyticsModelsReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "IncludeDraft", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "IncludeDeleted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 100, name: "Offset", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListAnalyticsModelsResp
 */
export const ListAnalyticsModelsResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListAnalyticsModelsResp",
  () => [
    { no: 1, name: "Models", kind: "message", T: AnalyticsModelSummary, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateAnalyticsModelReq
 */
export const CreateAnalyticsModelReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateAnalyticsModelReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Tags", kind: "message", T: AnalyticsTagsConfig },
    { no: 6, name: "Sections", kind: "message", T: AnalyticsSectionSpec, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateAnalyticsModelResp
 */
export const CreateAnalyticsModelResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateAnalyticsModelResp",
  () => [
    { no: 1, name: "Model", kind: "message", T: AnalyticsModel },
  ],
);

/**
 * Fields left unset keep their stored value. Organization ownership cannot be
 * changed here.
 *
 * @generated from message com.diagnocat.scribe.UpdateAnalyticsModelReq
 */
export const UpdateAnalyticsModelReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateAnalyticsModelReq",
  () => [
    { no: 1, name: "ModelID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Tags", kind: "message", T: AnalyticsTagsConfig, opt: true },
    { no: 7, name: "Sections", kind: "message", T: AnalyticsSectionSpecList, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateAnalyticsModelResp
 */
export const UpdateAnalyticsModelResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateAnalyticsModelResp",
  () => [
    { no: 1, name: "Model", kind: "message", T: AnalyticsModel },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteAnalyticsModelReq
 */
export const DeleteAnalyticsModelReq = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteAnalyticsModelReq",
  () => [
    { no: 1, name: "ModelID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteAnalyticsModelResp
 */
export const DeleteAnalyticsModelResp = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteAnalyticsModelResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreAnalyticsModelReq
 */
export const RestoreAnalyticsModelReq = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreAnalyticsModelReq",
  () => [
    { no: 1, name: "ModelID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreAnalyticsModelResp
 */
export const RestoreAnalyticsModelResp = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreAnalyticsModelResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.CloneAnalyticsModelReq
 */
export const CloneAnalyticsModelReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CloneAnalyticsModelReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Overrides", kind: "message", T: CatalogCloneOverride, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CloneAnalyticsModelResp
 */
export const CloneAnalyticsModelResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CloneAnalyticsModelResp",
  () => [
    { no: 1, name: "Result", kind: "message", T: CatalogCloneResult },
  ],
);

